export const options = [
  { value: "krosno", label: "Krosno", id: "city", strefa: "A" },
  { value: "krosinko", label: "Krosinko", id: "city", strefa: "A" },
  { value: "ludwikowo", label: "Ludwikowo", id: "city", strefa: "A" },
  { value: "mosina", label: "Mosina", id: "city", strefa: "A" },

  { value: "drużyna", label: "Drużyna", id: "city", strefa: "B" },
  { value: "nowinki", label: "Nowinki", id: "city", strefa: "B" },
  { value: "bogulin", label: "Bogulin", id: "city", strefa: "B" },
  { value: "borkowice", label: "Borkowice", id: "city", strefa: "B" },
  { value: "bolesławiec", label: "Bolesławiec", id: "city", strefa: "B" },
  { value: "dymaczewo stare", label: "Dymaczewo Stare", id: "city", strefa: "B" },

  { value: "sowiniec", label: "Sowiniec", id: "city", strefa: "C" },
  { value: "dymaczewo nowe", label: "Dymaczewo Nowe", id: "city", strefa: "C" },
  { value: "puszczykowo", label: "Puszczykowo", id: "city", strefa: "C" },
  { value: "pecna", label: "Pecna", id: "city", strefa: "C" },
  { value: "będlewo", label: "Będlewo", id: "city", strefa: "C" },
  { value: "łódź", label: "Łódź", id: "city", strefa: "C" },
  { value: "żabno", label: "Żabno", id: "city", strefa: "C" },
  { value: "żabinko", label: "Żabinko", id: "city", strefa: "C" },
];
